<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="faq-wrap">
    <div class="row">

      <div class="col-lg-8">
        <div class="header-faq">
          <h5 class="mb-0">Frequently Asked Questions</h5>
        </div>
        <div class="row default-according style-1 faq-accordion" id="accordionoc">
          <div class="col-xl-12 xl-60 col-lg-6 col-md-7">
            <div class="card">

              <div class="card-header">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed pl-0" (click)="isCollapsed1 = !isCollapsed1"
                    [attr.aria-expanded]="!isCollapsed1" aria-controls="collapse">
                    <app-feather-icons [icon]="'help-circle'"></app-feather-icons> Where can I report a problem with the application?
                  </button>
                </h5>
              </div>
              <div class="collapse" [ngbCollapse]="isCollapsed1">
                <div class="card-body">Despite the fact that we care about the quality of the solution, sometimes unexpected problems can occur.
                  You can send an email to the <a href="mailto:contact@inniver.com?subject=Problem%20report%20from%20publisher">support</a> (contact@inniver.com).
                  Please attach a description of the module in which you are observing the problem and what it is about.
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed pl-0" (click)="isCollapsed2 = !isCollapsed2"
                    [attr.aria-expanded]="!isCollapsed2" aria-controls="collapse">
                    <app-feather-icons [icon]="'help-circle'"></app-feather-icons> On what devices does the application work?
                  </button>
                </h5>
              </div>
              <div class="collapse" [ngbCollapse]="isCollapsed2">
                <div class="card-body">System Inniver is available in web version and works on desktops, tablets and mobile devices.</div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed pl-0" (click)="isCollapsed3 = !isCollapsed3"
                    [attr.aria-expanded]="!isCollapsed3" aria-controls="collapse">
                    <app-feather-icons [icon]="'help-circle'"></app-feather-icons>Where can I report new features that I would like to use in the system?
                  </button>
                </h5>
              </div>
              <div class="collapse" [ngbCollapse]="isCollapsed3">
                <div class="card-body">We make every effort to make the solution better and better.
                  Thank you for wanting to share your comments and you are actively involved in the development of our solution.
                  You can submit any suggestions to the <a href="mailto:contact@inniver.com?subject=Improvent%suggestion%20from%20publisher">contact's</a> account.</div>
              </div>
            </div>

            <!-- Payments GROUP -->
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed pl-0" (click)="isCollapsed8 = !isCollapsed8"
                    [attr.aria-expanded]="!isCollapsed8" aria-controls="collapse">
                    <app-feather-icons [icon]="'help-circle'"></app-feather-icons> How can I withdraw my money?
                  </button>
                </h5>
              </div>
              <div class="collapse" [ngbCollapse]="isCollapsed8">
                <div class="card-body">Good news for you, you don't need to request payment ! As long as your current revenue is over $ 50,
                  we will pay you automatically according to the schedule set for you.
                  We offer several payment methods, you can set the best one for yourself in the system.
                  Information can be found in the <a href="pub/payments"><b>Payments</b></a> menu.</div>
              </div>
            </div>


            <!-- User Accounts GROUP -->
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed pl-0" (click)="isCollapsed12 = !isCollapsed12"
                    [attr.aria-expanded]="!isCollapsed12" aria-controls="collapse">
                    <app-feather-icons [icon]="'help-circle'"></app-feather-icons> How can I change my password ?
                  </button>
                </h5>
              </div>
              <div class="collapse" [ngbCollapse]="isCollapsed12">
                <div class="card-body">Security is very important.
                  One of its elements is your account in the system and password.
                  We recommend that you change it regularly.
                  You can do it in several ways (the full description can be found in the User Manual), one of them is to change from your profile
                  (<a href="pub/profile"><b>My Profile</b></a> menu) in the system. Remember that the password cannot be shorter than 8 characters.<br><br>
                  <app-feather-icons [icon]="'alert-triangle'"></app-feather-icons>
                  The administrator may force you to change your password from time to time. Then follow the instructions.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">
                  <button class="btn btn-link collapsed pl-0" (click)="isCollapsed13 = !isCollapsed13"
                    [attr.aria-expanded]="!isCollapsed13" aria-controls="collapse">
                    <app-feather-icons [icon]="'help-circle'"></app-feather-icons> Where can I find instructions on how to use the system?
                  </button>
                </h5>
              </div>
              <div class="collapse" [ngbCollapse]="isCollapsed13">
                <div class="card-body">Currently, the full version of the
                  <a href="'../../../../../assets/documents/UserManual.pdf" download="UserManual"><b>User Manual</b></a> is available in pdf version.
                  You will find everything you need to use the system correctly.</div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="col-lg-4">        
        <div class="header-faq">
          <h5 class="mb-0">News</h5>
        </div>
        <div class="card">
          <div class="card-body faq-body">

            <div class="media updates-faq-main">
              <div class="updates-faq">
                <app-feather-icons class="font-primary" [icon]="'rotate-cw'"></app-feather-icons>
              </div>
              <div class="media-body updates-bottom-time">
                <p>System upgrade to the latest version, fix</p>
                <p>24 February 2024</p>
              </div>
            </div>

            <div class="media updates-faq-main">
              <div class="updates-faq">
                <app-feather-icons class="font-primary" [icon]="'rotate-cw'"></app-feather-icons>
              </div>
              <div class="media-body updates-bottom-time">
                <p>System upgrade to the latest version, fix</p>
                <p>2 February 2024</p>
              </div>
            </div>

            <div class="media updates-faq-main">
              <div class="updates-faq">
                <app-feather-icons class="font-primary" [icon]="'rotate-cw'"></app-feather-icons>
              </div>
              <div class="media-body updates-bottom-time">
                <p>System upgrade to the latest version, admin part</p>
                <p>29 January 2024</p>
              </div>
            </div>

            <div class="media updates-faq-main">
              <div class="updates-faq">
                <app-feather-icons class="font-primary" [icon]="'rotate-cw'"></app-feather-icons>
              </div>
              <div class="media-body updates-bottom-time">
                <p>System upgrade to the latest version, fix, small changes</p>
                <p>25 January 2024</p>
              </div>
            </div>

          </div>
        </div>
      </div
      >
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
